import styled from 'styled-components'

export const Wrapper = styled.div``

export const CropperWrapper = styled.div``

export const CropperContainerWrapper = styled.div`
  position: relative;
  height: 200px;
  .reactEasyCrop_Container {
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(33, 63, 104, 0.75);
  }
  .reactEasyCrop_CropArea {
    color: rgba(33, 63, 104, 0.75);
  }
  div > div {
    border-radius: 10px;
  }
`

export const CropperOptionsWrapper = styled.div`
  border: solid 1px rgba(220, 220, 220, 0.9);
  padding: 10px 15px;
  padding-bottom: 9px;
  border-radius: 0px 0px 10px 10px;
`

export const Subtitle = styled.div`
  color: #213f68;
  font-size: 14px;
`

export const ChangeImage = styled.div`
  text-align: left;
  button {
    height: 40px;
    border-radius: 8px;
    padding: 0 12px;
    background-color: rgba(158, 207, 250, 0.25) !important;
    color: rgb(38, 132, 255) !important;
    border: none;
    font-weight: 700;
    &:hover {
      color: rgba(38, 132, 255, 0.7) !important;
    }
  }
`
